import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    getListPerangkat: ({ commit, dispatch }, { loadDevice, deviceId }) => {
        let query = {
            offset: 0,
            limit: 500,
            status: 1,
        };
        commit("setFetching", true);
        commit("setResponse", {});

        conn.get(api.getListPerangkat, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200 && status) {
                    commit("setListPerangkat", data);
                    if (loadDevice) {
                        dispatch("getDetailTinyDevice", { deviceId });
                    } else {
                        commit("setResponse", resulter.successResult(msg));
                    }
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDetailTinyDevice: ({ commit, rootGetters }, { deviceId, dbreadonly }) => {
        commit("setFetching", true);
        commit("setResponse", {});

        let tokenJwt;
        if (!dbreadonly) {
            tokenJwt = rootGetters["waAutosenderModule/jwtToken"]();
        }

        let query = {
            readonly: tokenJwt?.Readonly || dbreadonly,
            api_key: "am9tYmxvaGdha3BheXU=",
        };

        conn.get(`${api.getDetailTinyDevice}/${deviceId}`, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    commit("setDataDeviceTiny", data);
                    commit("setResponse", resulter.successResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getWaStoryIndex: ({ commit }, { iddevice }) => {
        let query = {
            iddevice,
        };

        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(api.getWaStoryIndex, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    commit("setStoryIndex", data);
                    commit("setResponse", resulter.successResult(msg));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    createStatusNow: ({ commit }, payload) => {
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        commit("setFetching", true);
        commit("setResponse", {});

        return conn.post(api.createStatusNow, posted, conn.contentType.form);
    },
    createStatus: ({ commit }, payload) => {
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        commit("setFetching", true);
        commit("setResponse", {});

        return conn.post(api.createStatus, posted, conn.contentType.form);
    },
    getDetailStory: ({ commit }, { idstory }) => {
        let query = {
            idstory,
        };
        commit("setFetching", true);
        commit("setResponse", {});
        return conn.get(api.getDetailStory, query);
    },
};
